import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage } from './Dynamictable';

export default class Viewphones extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
        name: "World",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c'}],	
       
       tblfiterdata: [{username:"",uphone:""}]
 	
    };

    
   
    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
	
        const pid = localStorage.getItem("id");
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c'},{id:2, nm: 'd'}]
	
	const cols = ["Name","Phone"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        this.getcompdata(pid);

    }
 
 getcompdata(eid: any){
	 try {
         const path = Configdata.srvurl + '/getusersphone?prd='+eid+'&mpd='+'1-150'; 
 	//alert(path);	
	axios.get(path)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata);
            })
            .catch((err: any) => {
                alert(err);
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1) farr.shift();
	this.setState({ tblfiterdata: farr});
      }	

    
 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheaders.map((str,index)=>(
			<th className="comptd">{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
			<tr>
				<td className="comptd">{row.username}</td>
				<td className="comptd">{row.uphone}</td>
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

